import BannerList from 'components/Content/BannerList/BannerList';
import { withBannerListProps } from 'viewModel/bcc/bccBannerList/withBannerListProps';

export default withBannerListProps(BannerList);
